module.exports = __webpack_public_path__ + "static/media/bg_women.5aaea342.png";